import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, InfoOutlineIcon, Text } from '@common-fe/common-fe';

const QuestionnaireHint = () => {
  const { t } = useTranslation();

  return (
    <Box
      direction="column"
      border={{ size: 'small', color: 'infoBorder' }}
      round="container2Round"
      background="infoContainer"
      style={{ position: 'relative' }}
      pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
    >
      <Box
        round="1px"
        style={{ position: 'absolute', top: '-1px', left: '24px', right: '24px' }}
        height="2px"
        background="info"
      />
      <Box direction="row" align="center">
        <InfoOutlineIcon color="info" size="24px" />
        <Text size="large" weight={700} margin={{left: 'spacing8'}}>
          {t('Why are we asking?')}
        </Text>
      </Box>

      <Text size="large" weight={400} margin={{ top: 'spacing8' }}>
        {t(
          'Investment accounts must comply with compliance and regulatory requirements; these questions are in compliance with U.S. regulatory requirements. We will not use this information for any other purposes.'
        )}
      </Text>
    </Box>
  );
};

export default QuestionnaireHint;
